module.exports = __webpack_public_path__ + "img/pastel.c5ec7e35.png";